import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { StimulsoftViewerModule } from 'stimulsoft-viewer-angular';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ReportCenterService } from '../../../services/report-center.service';
import { gridPageRequest } from '../../../model/common/common.model';
import { Table } from 'primeng/table';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-report-list',
  standalone: true,
  imports: [SharedModule, StimulsoftViewerModule, CommonModule],
  templateUrl: './report-list.component.html',
  styleUrl: './report-list.component.scss'
})

export class ReportListComponent implements OnInit {
  searchKey: string | undefined;
  @ViewChild('dt1') dt1: Table | undefined;


  constructor(private messageService: MessageService, private reportcenterService: ReportCenterService) { }

  reportList: any[] = [];

  visible: boolean = false;
  loader: boolean = false;
  title: string | undefined;
  path: string = '';

  warn: boolean = false;
  addReport: boolean = false;
  isEdit: boolean = false;
  selectedReport: any[] = [];
GroupNameList: any[] = [];
selectedGroupName: string = '';

  properties = { ReportName: '', TenantId: 'default' };

  createReport = new FormGroup({
    // ReportId: new FormControl(0),
    Name: new FormControl('', Validators.required),
    Description: new FormControl('', Validators.required),
    Path: new FormControl('', Validators.required),
    CreatedBy: new FormControl(''),
    UpdatedBy: new FormControl(''),
    GroupName: new FormControl(''),

  });

  ngOnInit(): void {
    document.title = 'Report Center'
    this.createReport.controls.CreatedBy.setValue(localStorage.getItem('username'));
    this.getReportList();
    this.getGroupNames();
    this.searchEffect();

  }

 pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 50,
    id: 0
  };

  openReport(value: any) {
    this.visible = true;
    this.title = value.name;
    document.title = value.name;
    try {
      const authString = localStorage.getItem('auth');
      if (!authString) {
        throw new Error('Auth information is missing');
      }

      const auth = JSON.parse(authString);
      if (!auth.tenant?.tenantCode) {
        throw new Error('Tenant Code is missing');
      }

      const tenant = auth.tenant.tenantCode;

      // var base_url = new URL(window.location.href).origin;
      this.path = `${environment.apiBaseUrl}/GetReportByName/{action}`;
    //  this.path = `https://localhost:7109/api/GetReportByName/{action}`;

      this.properties = {
        ReportName: value.path,
        TenantId: tenant
      };

    } catch (error: any) {
      console.error(error);
    }

  }


  showDialog() {
    this.addReport = !this.addReport;
  }

  create() {
    if (this.createReport.invalid) {
      this.warn = true;
      this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please fill all field' });
      return;
    }

    this.loader = true;
    this.reportcenterService.createReport(this.createReport.value).subscribe(
      (data: any) => {
        if (data.success === true) {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: data.message });
          this.loader = false;
          this.showDialog();
          this.getReportList();
          this.createReport.reset();
          this.createReport.controls.CreatedBy.setValue(localStorage.getItem('username'));
        } else {
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: data.message });
          this.loader = false;
        }
      },
      (error: any) => {
        console.log(error);
        this.loader = false;
      }
    );

  }

  update() {

  }

  getReportList() {
    this.loader = true
    this.reportcenterService.getReportList().subscribe(
      (data: any) => {
        if (data) {
          this.reportList = data;
          this.loader = false;
        }
      },
      (error: any) => {
        console.log(error);
        this.loader = false;
      }
    );
  }
  loadpayments(event:any){
    if (this.searchKey && this.searchKey.trim() !== '') {
      this.SearchReport();
    } else {
      this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
      this.getReportList();
    }
  }
  refreshData(): void {
    if (this.dt1) {
      this.dt1.first = 0; 
      this.dt1.clear();
    }
    this.searchKey = ''; 
     this.selectedGroupName = '';
    this.pageRequest.pageIndex = 0;
    this.pageRequest.pageSize = 50; 
    this.getReportList(); 
    this.getGroupNames();
  }
  SearchReport() {
    if (!this.searchKey) {
      return;
    }
    this.reportcenterService.autoSearchReport(this.searchKey).subscribe(
      (data: any) => {
        if (data) {
          this.reportList = data;
          if (this.dt1) {
            this.dt1.first = 0;
          }
        } else {
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }
  getReport(Status: string) {
    this.loader = true
    this.reportcenterService.getReport(this.pageRequest,Status).subscribe(
      (data: any) => {
        if (data) {
          this.reportList = data;
          this.loader = false;
        }
      },
      (error: any) => {
        console.log(error);
        this.loader = false;
      }
    );
  }
onGroupNameChange(event: any) {
  if (this.dt1) {
    this.dt1.first = 0;
  }

  this.pageRequest.pageIndex = 0;

  this.getReport(event.value);
}

  // getReport(Status: string) {
  //   this.reportcenterService.getReport(this.pageRequest,Status).subscribe({
  //     next: (data: any) => {
  //       this.reportList = data.reportList;
        
  //     },
  //     error: (error: any) => {
  //       console.log(error);
  //     }
  //   });
  // }

  getGroupNames() {
  this.reportcenterService.getGroupNames().subscribe(
    (data: string[]) => {
      this.GroupNameList = data
        .filter(group => group !== null)
        .map(group => ({
          label: group,
          value: group
        }));
    },
    (error: any) => {
      console.error('Error fetching group names', error);
    }
  );
}

  placeholder: string = 'Search By ';
  private messages: string[] = ['Report Category', 'Report Number', 'Name', 'Description'];
  private messageIndex = 0;
  private charIndex = 0;


  searchEffect() {
    const base = 'Search By ';
    const typeNextChar = () => {
      if (this.charIndex <= this.messages[this.messageIndex].length) {
        this.placeholder = base + this.messages[this.messageIndex].substring(0, this.charIndex);
        this.charIndex++;
        setTimeout(typeNextChar, 150);
      } else {
        setTimeout(() => {
          this.messageIndex = (this.messageIndex + 1) % this.messages.length;
          this.charIndex = 0;
          typeNextChar();
        }, 1000);
      }
    };
    typeNextChar();
  }


}
